//
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import ItemFeedbackStore from 'bundles/content-feedback/stores/ItemFeedbackStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';
import routes from 'bundles/video-logged-out-page/routes';
import VideoTranscriptStore from 'bundles/video-logged-out-page/stores/VideoTranscriptStore';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(VideoTranscriptStore);
appEnv.registerStore(ItemFeedbackStore);

export default appEnv;
